import { render, staticRenderFns } from "./ScheduleBoardPage.vue?vue&type=template&id=4e238b0d&scoped=true&"
import script from "./ScheduleBoardPage.vue?vue&type=script&lang=js&"
export * from "./ScheduleBoardPage.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleBoardPage.vue?vue&type=style&index=0&id=4e238b0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e238b0d",
  null
  
)

export default component.exports